import './App.css';
import CadreJeu from './components/CadreJeu';
import Header from './components/Header'

function App() {
  return (
    <div className="App">
      <Header />
      <CadreJeu />
    </div>
  );
}

export default App;
